import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { prettyMatchUrl } from '../../common/rcs_gaz_mc_core_FE';
import Label from '../shared/Label';
import TeamLabel from '../shared/TeamLabel';
import Result from '../TimeResults/Result';
import Timing from '../TimeResults/Timing';
import { MatchWidgetWrapper, NextMatchWrapper, DataMatchWrapper, DataMatchWrapperPoint, TeamLink } from './styles';
import ConfigManager from '../../common/configManager/configManager';
import DateLabel from '../shared/DateLabel';

class TeamNextWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }

  componentDidMount() {
    this.resizeCallback();
    window.addEventListener('resize', this.resizeCallback);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
  }

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= 1023,
    });
  };

  isHomeWinner = () => (Number(this.props.match.getIn(['homeTeam', 'score'])) > Number(this.props.match.getIn(['awayTeam', 'score'])))
    && this.props.match.get('status') !== 'LIVE';
  isAwayWinner = () => (Number(this.props.match.getIn(['homeTeam', 'score'])) < Number(this.props.match.getIn(['awayTeam', 'score'])))
    && this.props.match.get('status') !== 'LIVE';
  isLive = () => this.props.match.get('status') === 'LIVE';

  nextMatchTiming = (status) => {
    let returnedValue = '';
    switch (status) {
      case 'PREMATCH':
        returnedValue = 'Prossima partita:';
        break;
      case 'LIVE':
        returnedValue = 'Live ora: ';
        break;
      case 'FULL':
        returnedValue = 'Ultima Partita: ';
        break;
      default:
        returnedValue = 'Prossima Partita: ';
    }
    return returnedValue;
  };

  render() {
    const { isMobile } = this.state;
    const { match, dictionary, sportId } = this.props;
    const teamsImageUrl = ConfigManager.getFootballTeams('min');
    const awayResPen = (match.getIn(['awayTeam', 'starData', 'shootOuts', 'score'])) ?
      match.getIn(['awayTeam', 'starData', 'shootOuts', 'score']) : 0;
    const homeResPen = (match.getIn(['homeTeam', 'starData', 'shootOuts', 'score'])) ?
      match.getIn(['homeTeam', 'starData', 'shootOuts', 'score']) : 0;

    return (
      <MatchWidgetWrapper>
        <NextMatchWrapper>
          {match && match.get('competitionId') && match.get('status') &&
          <div style={{
            paddingTop: isMobile ? '4px' : '0px',
          }}
          >
            <Label
              label={`${this.nextMatchTiming(match.get('status'))}`}
              lineHeight={1.9}
              size={isMobile ? 0.8 : 0.9}
            />
            <Label
              label={`${dictionary.competitionTable.competitionName[match.get('competitionId')]}`}
              lineHeight={1.9}
              margin="0 0 0 6px"
              weight="bold"
              size={isMobile ? 0.8 : 0.9}
            />
          </div>
          }
        </NextMatchWrapper>
        <div className="HeaderShadow" />
        {match && match.getIn(['homeTeam', 'teamName']) && match.get('competitionId') &&
          <DataMatchWrapper>
            <TeamLink
              href={ConfigManager.prettyTeamUrl(1, match.get('competitionId'), process.env.REACT_APP_SITE, match.getIn(['homeTeam', 'teamName']))}
            >
              <TeamLabel
                size={isMobile ? 13 : 15}
                label={match.getIn(['homeTeam', 'teamName'])}
                image={`${teamsImageUrl}/${match.getIn(['homeTeam', 'teamId'])}.png`}
                marginLeft={0.5}
                textWidth={isMobile ? '60px' : '100px'}
                font={this.isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
              />
            </TeamLink>
            <DataMatchWrapperPoint
              href={prettyMatchUrl(
                match.getIn(['homeTeam', 'teamName']), match.getIn(['awayTeam', 'teamName']), match.get('matchId'),
                sportId, match.get('competitionId'), process.env.REACT_APP_SITE,
              )}
            >
              {match.get('utcDate') && match && match.get('status') === 'PREMATCH' &&
                <span>
                  <DateLabel
                    date={match.get('utcDate')}
                    noYears
                    weight="bold"
                    size="0.8"
                    lightSkin
                  />
                  <Timing
                    dictionary={dictionary}
                    timing={match.get('timing')}
                    date={match.get('utcDate')}
                    isMobile={isMobile}
                    isLive={this.isLive()}
                    size="0.8"
                    margin="4px 0px 0px 0px"
                  />
                </span>
              }
              {match && match.get('status') === 'LIVE' &&
                <span>
                  <Result
                    awayRes={match.getIn(['awayTeam', 'score'])}
                    homeRes={match.getIn(['homeTeam', 'score'])}
                    status={match.get('status')}
                    awayPenRes={awayResPen}
                    homePenRes={homeResPen}
                    size="0.8"
                    isNext
                  />
                  <Timing
                    dictionary={dictionary}
                    timing={match.get('timing')}
                    date={match.get('utcDate')}
                    isMobile={isMobile}
                    isLive={this.isLive()}
                    size="0.8"
                    margin="4px 0px 0px 0px"
                  />
                </span>
              }
              {match && match.get('status') === 'FULL' &&
                <span>
                  <Result
                    awayRes={match.getIn(['awayTeam', 'score'])}
                    homeRes={match.getIn(['homeTeam', 'score'])}
                    status={match.get('status')}
                    awayPenRes={awayResPen}
                    homePenRes={homeResPen}
                    size="0.8"
                    isNext
                  />
                  <Label
                    label={dictionary.competitionTable.timing.FINISHED}
                    size="0.8"
                  />
                </span>
              }
            </DataMatchWrapperPoint>
            {match && match.getIn(['awayTeam', 'teamName']) && match.get('competitionId') &&
              <TeamLink
                href={ConfigManager.prettyTeamUrl(1, match.get('competitionId'), process.env.REACT_APP_SITE, match.getIn(['awayTeam', 'teamName']))}
              >
                <TeamLabel
                  size={isMobile ? 13 : 15}
                  label={match.getIn(['awayTeam', 'teamName'])}
                  image={`${teamsImageUrl}/${match.getIn(['awayTeam', 'teamId'])}.png`}
                  isMatchPageInverse={!isMobile}
                  marginRight={0.5}
                  marginLeft={0.5}
                  textWidth={isMobile ? '60px' : '100px'}
                  font={this.isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
                  alignment={isMobile ? 'left' : 'right'}
                />
              </TeamLink>
            }
          </DataMatchWrapper>
        }
      </MatchWidgetWrapper>
    );
  }
}

TeamNextWidget.propTypes = {
  dictionary: PropTypes.any,
  match: PropTypes.any,
  sportId: PropTypes.any,
  //actions: PropTypes.any,
};

export default TeamNextWidget;



// WEBPACK FOOTER //
// ./src/components/TeamNextWidget/index.js